export const googleMapsStyles = {
  circularProgress: {
    margin: '0 45%',
  },
};
